export enum SecondaryDialogTypeEnum {
    SalesType = 1,
    AddAnimal = 2,
    ModifyCollectWeek = 3,
    SlaughterOrIntermediationAnnouncement = 4,
}
